import { Link } from 'react-router-dom';
import { ServiceProps } from '../../../pages/ServicesPage';
import { ModelsService } from '../../../services/ModelsService';
import { SanitizeHTML } from '../../globals/SanitizeHTML';
import { IconSize, ServiceIcon } from '../ServiceIcon';

/**
 * Service item
 * @param props
 * @returns
 */
export const ServiceItem: React.FC<ServiceProps> = ({ service }) => {
  return (
    <li
      className="relative col-span-1 flex flex-col h-52 text-left bg-cover bg-no-repeat bg-white bg-opacity-70 border border-opacity-40 rounded-xl overflow-hidden"
      style={{ borderColor: service.acf.color }}
    >
      <Link
        to={
          service.slug === 'emergency'
            ? '/emergency'
            : ModelsService.getServiceFullSlug(service)
        }
        className="flex w-full h-full justify-between"
      >
        <div className="bg-white flex flex-col w-full h-full">
          {service.acf.image ? (
            <img
              src={service.acf.image?.sizes?.medium}
              alt=""
              className="!h-28 object-cover"
            />
          ) : (
            <div
              className="h-28 w-full"
              style={{ backgroundColor: service.acf.color }}
            ></div>
          )}
          <div className="flex flex-col space-y-2 items-start h-3/6 justify-start px-4 pt-8 pb-0 bg-white rounded-xl -mt-8 shadow-none drop-shadow-none">
            <SanitizeHTML
              tag="p"
              html={service.title.rendered}
              className="text-lg font-medium leading-none"
            />
            {service.acf.subtitle ? (
              <SanitizeHTML
                tag="p"
                html={service.acf.subtitle}
                className="opacity-50 w-full text-xs leading-none"
              />
            ) : (
              ''
            )}
          </div>
          <div className="absolute w-full flex justify-center items-center text-center top-14">
            {service.acf.icon && (
              <ServiceIcon service={service} size={IconSize.medium} />
            )}
          </div>
        </div>
      </Link>
    </li>
  );
};
